import request from 'local_modules/request'
import { reducers } from 'redux/core'
import { constants, getQuery } from 'helpers'


// busNumber [], routeNumber, []
const fetch = ({ filters: query = {}, fetchCount }) => {
  reducers.lscTransportControl.tableDeviations.setFetching(true)

  const query1 = getQuery({
    busNumber: query.bus,
    routeNumber: query.route,
    startDate: query.dateFrom,
    endDate: query.dateTo,
    offset: query.offset || 0,
  })

  const query2 = getQuery({
    busNumber: query.bus,
    routeNumber: query.route,
    startDate: query.dateFrom,
    endDate: query.dateTo,
    offset: query.offset || 0,
    limit: query.limit,
  })

  return Promise.all([
    request.get(constants.lscTransportControl.deviationsCount + query1),
    // fetchCount ? request.get(constants.lscTransportControl.deviationsCount + query1) : Promise.resolve({ data: {}}),
    request.get(constants.lscTransportControl.deviations + query2)
  ])
    .then(([ { data: { count } }, { data: body }]) => {

      const data = body.map(({
        arrivedAt, // "14:44:45"
        busNumber, // "681"
        date, // "2019-05-01"
        routeNumber, // "9"
        scheduledTime, // "14:39"
        stationName, // "Четвертая"
        deviation,
        status, // "delay"
      }) => ({
        arrivedAt, // "14:44:45"
        busNumber, // "681"
        date, // "2019-05-01"
        routeNumber, // "9"
        scheduledTime, // "14:39"
        stationName, // "Четвертая"
        deviation,
        status, // "delay"
      }))

      if (data.length > query.limit) {
        reducers.lscTransportControl.tableDeviations.setData(
          [...data].splice(query.offset || 0, query.limit || 10)
        )
      }
      else {
        reducers.lscTransportControl.tableDeviations.setData(data)
      }

      if (count) {
        reducers.lscTransportControl.tableDeviations.setPages(Math.ceil(count / (query.limit || 10)))
      }

      // if (!query.offset) {
      //   reducers.lscTransportControl.tableDeviations.setActivePageId(1)
      // }

      reducers.lscTransportControl.tableDeviations.setFetching(false)
    })
    .catch((err) => {
      console.log(err)
      reducers.lscTransportControl.tableDeviations.setFetching(false)
    })
}


const setActivePageId = (activePageId) =>
  reducers.lscTransportControl.tableDeviations.setActivePageId(activePageId)

const setPages = (pages) =>
  reducers.lscTransportControl.tableDeviations.setPages(pages)


export default {
  fetch,
  setPages,
  setActivePageId,
}
